import { useEffect, useState, RefObject } from 'react'

interface Dimensions {
  width: number
  height: number
}

export const useResizeObserver = (
  containerRef: RefObject<HTMLElement> | RefObject<HTMLDivElement | null>,
  debounceMs: number = 100
): Dimensions => {
  const [dimensions, setDimensions] = useState<Dimensions>({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  useEffect(() => {
    let timeoutId: NodeJS.Timeout

    const handleResize = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        if (containerRef.current) {
          setDimensions({
            width: containerRef.current.clientWidth,
            height: containerRef.current.clientHeight,
          })
        } else {
          setDimensions({
            width: window.innerWidth,
            height: window.innerHeight - 84 - 123,
          })
        }
      }, debounceMs)
    }

    // Set initial dimensions
    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      clearTimeout(timeoutId)
      window.removeEventListener('resize', handleResize)
    }
  }, [containerRef, debounceMs])

  return dimensions
}
